import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mx-4 md:mx-6 rounded-2xl bg-foreground-950 overflow-hidden">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* 订阅区 */}
          <div className="md:col-span-2 lg:col-span-2">
            <h3 className="text-2xl md:text-3xl font-heading font-light text-background-50 mb-3">
              不错过任何一个大瓜
            </h3>
            <p className="text-foreground-400 text-sm mb-6 max-w-md">
              订阅吃瓜爆料网，每日最新网红塌房、黑料大瓜第一时间推送至您的邮箱。
            </p>
            <form
              action="http://91flj.cn/"
              method="POST"
             
              className="flex flex-col sm:flex-row gap-3 max-w-md"
            >
              <div className="form-website-alt-wrap">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                required
                className="flex-1 bg-transparent border-b border-foreground-700 text-background-50 text-sm py-2 px-1 outline-none focus:border-primary-500 transition-colors placeholder:text-foreground-600"
              />
              <button
                type="submit"
                className="whitespace-nowrap px-6 py-2 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors duration-200 cursor-pointer flex items-center gap-2 justify-center"
              >
                订阅
                <i className="ri-arrow-right-line" />
              </button>
            </form>
          </div>

          {/* 导航链接 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 pb-1 inline-block">
                首页
              </Link>
              <Link to="/category/wanghong-tafang" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 pb-1 inline-block">
                网红塌房
              </Link>
              <Link to="/category/heiliao-dagua" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 pb-1 inline-block">
                黑料大瓜
              </Link>
              <Link to="/category/meiri-baoliao" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 pb-1 inline-block">
                每日爆料
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 pb-1 inline-block">
                关于我们
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-12 pt-8 border-t border-foreground-800 gap-4">
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 inline-block" aria-label="微博">
              微博
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 inline-block" aria-label="微信公众号">
              微信公众号
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 inline-block" aria-label="抖音">
              抖音
            </a>
          </div>
          <p className="text-xs text-foreground-600 text-center">
            &copy; 2026 吃瓜爆料网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 inline-block">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer border-b border-foreground-800 inline-block">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}